// Types TypeScript pour l'application appointments (prise de RDV WhatsApp)

export interface DisponibiliteMedecin {
  id: number;
  doctor: number;
  doctor_details: {
    id: number;
    nom_complet: string;
    speciality: string;
  };
  jour_semaine: number;
  jour_semaine_display: string;
  matin_debut: string | null;   // "HH:MM"
  matin_fin: string | null;
  aprem_debut: string | null;
  aprem_fin: string | null;
  duree_creneau: 10 | 15 | 20 | 30 | 45 | 60;
  duree_creneau_display: string;
  chevauchement_tolere: ChevauchementTolere;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface JourFerie {
  id: number;
  date: string;         // "YYYY-MM-DD"
  motif: string;
  tout_cabinet: boolean;
  medecins_concernes: number[];
  medecins_concernes_details: Array<{
    id: number;
    nom_complet: string;
    speciality: string;
  }>;
  created_at: string;
}

export interface SessionWhatsApp {
  id: number;
  telephone: string;
  etape_courante: string;
  etape_label: string;
  contexte: Record<string, unknown>;
  rdv_en_cours: number | null;
  erreurs_consecutives: number;
  est_expiree: boolean;
  created_at: string;
  updated_at: string;
}

export interface ConfigWhatsApp {
  id: number;
  phone_number_id: string;
  waba_id: string;
  template_rappel: string;
  template_langue: string;
  latitude: string;
  longitude: string;
  adresse_cabinet: string;
  flow_inscription_id: string;
  message_bienvenue: string;
  service_actif: boolean;
  mode_maintenance: boolean;
  message_maintenance: string;
  email_alerte: string;
  created_at: string;
  updated_at: string;
}

export interface FaqEntry {
  id: number;
  question: string;
  reponse: string;
  mots_cles: string;          // séparés par des virgules
  envoyer_position: boolean;
  lister_assurances: boolean; // liste des assureurs insérée à la place de {assurances}
  ordre: number;
  actif: boolean;
  updated_at: string;
}

export interface MessageWhatsAppLog {
  id: number;
  telephone: string;
  direction: 'entrant' | 'sortant';
  contenu: string;
  statut: 'envoye' | 'livre' | 'lu' | 'echec';
  message_id_provider: string;
  erreur: string;
  created_at: string;
}

export interface CrenauHoraire {
  heure: string;       // "HH:MM:SS"
  heure_str: string;   // "HH:MM"
  disponible: boolean;
  rdv_id: number | null;
}

export interface JourDisponible {
  jour_semaine: number;
  jour_label: string;
  configure: boolean;
  actif: boolean;
  dispo_id: number | null;
  matin_debut: string | null;
  matin_fin: string | null;
  aprem_debut: string | null;
  aprem_fin: string | null;
  duree_creneau: number;
  chevauchement_tolere: ChevauchementTolere;
}

export interface GrilleMedecin {
  doctor_id: number;
  doctor_nom: string;
  doctor_specialite: string;
  jours: JourDisponible[];
}

export interface PreviewCreneaux {
  date: string;
  doctor_id: number;
  creneaux: CrenauHoraire[];
  nb_disponibles: number;
  nb_total: number;
}

export interface StatistiquesWhatsApp {
  rdv_pris_whatsapp: number;
  messages_recus: number;
  messages_envoyes: number;
  echecs_envoi: number;
  sessions_actives: number;
  sessions_accueil: number;   // reprises par l'accueil : le bot se tait
}

export type DureeCreneau = 10 | 15 | 20 | 30 | 45 | 60;

export const JOURS_SEMAINE = [
  { value: 0, label: 'Lundi' },
  { value: 1, label: 'Mardi' },
  { value: 2, label: 'Mercredi' },
  { value: 3, label: 'Jeudi' },
  { value: 4, label: 'Vendredi' },
  { value: 5, label: 'Samedi' },
  { value: 6, label: 'Dimanche' },
];

export type ChevauchementTolere = 0 | 15 | 20;

/** Recouvrement admis entre deux RDV (jamais à la même heure de début). */
export const CHEVAUCHEMENTS: Array<{ value: ChevauchementTolere; label: string }> = [
  { value: 0, label: 'Aucun' },
  { value: 15, label: '15 min' },
  { value: 20, label: '20 min' },
];

export const DUREES_CRENEAU: Array<{ value: DureeCreneau; label: string }> = [
  { value: 10, label: '10 min' },
  { value: 15, label: '15 min' },
  { value: 20, label: '20 min' },
  { value: 30, label: '30 min' },
  { value: 45, label: '45 min' },
  { value: 60, label: '1 heure' },
];
